import { createContext, useContext, useState } from 'react';

const OrcamentoContext = createContext(null);

export function OrcamentoProvider({ children }) {
  // Step 1: upload config
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [tipo, setTipo] = useState('casa_terrea');
  const [padrao, setPadrao] = useState('normal');
  const [estado, setEstado] = useState('SP');

  // Step 2: AI analysis result
  const [analise, setAnalise] = useState(null);

  // Step 3: user-validated data
  const [validacao, setValidacao] = useState(null);

  // Step 4: calculated result
  const [resultado, setResultado] = useState(null);

  const setConfig = ({ file: f, filePreview: fp, tipo: t, padrao: p, estado: e }) => {
    if (f !== undefined) setFile(f);
    if (fp !== undefined) setFilePreview(fp);
    if (t !== undefined) setTipo(t);
    if (p !== undefined) setPadrao(p);
    if (e !== undefined) setEstado(e);
  };

  const clearOrcamento = () => {
    setFile(null);
    setFilePreview(null);
    setTipo('casa_terrea');
    setPadrao('normal');
    setEstado('SP');
    setAnalise(null);
    setValidacao(null);
    setResultado(null);
  };

  return (
    <OrcamentoContext.Provider value={{
      file, filePreview, tipo, padrao, estado,
      analise, validacao, resultado,
      setConfig, setAnalise, setValidacao, setResultado,
      clearOrcamento,
    }}>
      {children}
    </OrcamentoContext.Provider>
  );
}

export function useOrcamento() {
  const context = useContext(OrcamentoContext);
  if (!context) {
    throw new Error('useOrcamento deve ser usado dentro de um OrcamentoProvider');
  }
  return context;
}
